import type { ButtonProps } from '@mui/material';
import { Button } from '@mui/material';
import type { ButtonTypeMap } from '@mui/material/Button';
import React from 'react';

export function CtaButton<
  RootComponent extends React.ElementType = ButtonTypeMap['defaultComponent'],
  AdditionalProps = object,
>(props: ButtonProps<RootComponent, AdditionalProps>) {
  return <Button variant="contained" size="medium" {...props} />;
}
